import React from 'react';
import { XCircleIcon, CheckCircle2Icon } from 'lucide-react';
import { beforeItems, afterItems, transformationBadges } from '../data/kit';
export function TransformationSection() {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-170" data-mp="2wx4bztf1pat6">
      <div className="max-w-5xl mx-auto" data-id="element-171" data-mp="2wvsyh1vssoov">
        <div className="flex flex-col md:flex-row gap-12 items-center mb-16" data-id="element-172" data-mp="2rysz19tgek6q">
          <div className="flex-1" data-id="element-173" data-mp="2s0x6u2uh43ca">
            <h2 className="text-4xl md:text-5xl font-black text-brand-text leading-[1.1] tracking-tight mb-6" data-id="element-174" data-mp="2nx7fj5mez7nk">
              De una instructora sobrecargada a una profesional con{' '}
              <span className="italic text-brand-terracottaText" data-id="element-175" data-mp="2e6mllvhoqraz">
                todo resuelto
              </span>
            </h2>
            <div className="inline-flex items-center gap-4 bg-white/70 p-4 rounded-2xl" data-id="element-176" data-mp="299dzxkxbw54z">
              <span className="text-4xl font-serif font-bold text-brand-terracottaText" data-id="element-177" data-mp="247x2y0hyt2to">
                +300
              </span>
              <span className="text-sm text-brand-gray font-medium max-w-[170px] leading-tight" data-id="element-178" data-mp="2086dc046csqq">
                ejercicios ilustrados, listos para llevar a la sala.
              </span>
            </div>
          </div>

          <div className="flex-1 w-full bg-white rounded-3xl shadow-sm border border-brand-creamDark grid grid-cols-2 overflow-hidden" data-id="element-179" data-mp="5cwiyt2hmvaw">
            <div className="bg-brand-terracottaSoft p-5 md:p-7" data-id="element-180" data-mp="ab7pouxhkpow">
              <div className="flex items-center gap-2 mb-6" data-id="element-181" data-mp="y1k8j0u9s6u9">
                <XCircleIcon className="w-6 h-6 text-brand-cross shrink-0" aria-hidden="true" data-id="element-182" data-mp="y23jfxli5uys" />
                <h3 className="text-xs md:text-sm font-bold uppercase tracking-wider text-brand-terracottaText leading-tight" data-id="element-183" data-mp="p15jpri3k9m0">
                  Antes
                </h3>
              </div>
              <ul className="space-y-5" data-id="element-184" data-mp="39r4ipbh5z8ch">
                {beforeItems.map(item => <li key={item} className="flex items-start gap-2.5 text-brand-text" data-id="element-185" data-mp="39th3dweb3wt8">
                    <XCircleIcon className="w-5 h-5 text-brand-cross shrink-0 mt-0.5" aria-hidden="true" data-id="element-186" data-mp="1k8xsfarodar0" />
                    <span className="text-sm md:text-base font-medium leading-snug" data-id="element-187" data-mp="1ajwavg5helax">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-brand-greenSoft p-5 md:p-7 border-l border-brand-creamDark" data-id="element-188" data-mp="11jrfy5hh5fdn">
              <div className="flex items-center gap-2 mb-6" data-id="element-189" data-mp="wk54a0hao76y">
                <CheckCircle2Icon className="w-6 h-6 text-brand-check shrink-0" aria-hidden="true" data-id="element-190" data-mp="wmr9vukmkcmj" />
                <h3 className="text-xs md:text-sm font-bold uppercase tracking-wider text-brand-greenDeep leading-tight" data-id="element-191" data-mp="mna47d5dhyqk">
                  Con Pilates Listo
                </h3>
              </div>
              <ul className="space-y-5" data-id="element-192" data-mp="2h1b666w7z1uv">
                {afterItems.map(item => <li key={item} className="flex items-start gap-2.5 text-brand-text" data-id="element-193" data-mp="2pi1zxd1xjo75">
                    <CheckCircle2Icon className="w-5 h-5 text-brand-check shrink-0 mt-0.5" aria-hidden="true" data-id="element-194" data-mp="2tgr90tfxqjkz" />
                    <span className="text-sm md:text-base font-semibold leading-snug" data-id="element-195" data-mp="3385gbne4onoo">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-196" data-mp="2fj2stywtc0m9">
          {transformationBadges.map(badge => <div key={badge.label} className="bg-white px-6 py-3 rounded-full shadow-sm border border-brand-creamDark flex flex-col items-center" data-id="element-197" data-mp="2kifn34q0k9yv">
              <span className="font-serif font-bold text-xl text-brand-text" data-id="element-198" data-mp="3vwt69w9to18k">
                {badge.value}
              </span>
              <span className="text-[10px] uppercase tracking-wider text-brand-gray" data-id="element-199" data-mp="18poepdcdk3gj">
                {badge.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}